'use client';

import { ReactNode, createContext, useContext } from 'react';

import { defaultHosts as devDefaultHosts, env as devEnv } from './env/dev';
import { Env } from './env/env.type';

const context = createContext<Env>(
  devEnv({
    hosts: devDefaultHosts,
  })
);

export function useEnv() {
  return useContext(context);
}

type PropsProviderEnv = {
  children: ReactNode;
  env: Env;
};

export function ProviderEnv({ children, env }: PropsProviderEnv) {
  return <context.Provider value={env}>{children}</context.Provider>;
}
